import { IconName } from "@/config/icons"

export enum SidebarItemType {
  Nest = 'nest',
  Link = 'link'
}

export interface SidebarItem {
  key: string
  title: string
  icon?: IconName
  href?: string
  type?: SidebarItemType
  isDivider?: boolean
  items?: SidebarItem[]
}

export const APP_SIDEBAR_ITEMS: SidebarItem[] = [
  // Main Navigation Items
  // { key: 'gallery', title: 'Gallery', icon: 'image', href: '/gallery' },
  // { key: 'products', title: 'Products', icon: 'cart', href: '/products' },
  // { key: 'articles', title: 'Articles', icon: 'file-text', href: '/articles' },
  // { key: 'locations', title: 'Locations', icon: 'map-pin', href: '/locations' },
  // { key: 'about', title: 'Info', icon: 'info', href: '/about' },

]

export const APP_SIDEBAR_CONFIG = {
  gestures: {
    edge: { threshold: 20, swipeDistance: 50 },
    velocity: { min: 0.3, max: 2.0 }
  },
  contextRules: {
    keyboardOpen: false,
    navigationActive: false,
    scrolling: false
  },
  animations: {
    open: 300,
    close: 250,
    bounce: 500,
    easing: {
      enter: 'cubic-bezier(0.4, 0, 0.2, 1)',
      exit: 'cubic-bezier(0.4, 0, 1, 1)'
    }
  }
}
